import React, { useEffect, useState } from "react";
import DisciplineCard from "./DisciplineCard";
import { getAllDisciplines } from "../../../services/disciplinesServices";
import SectionTitle from "../../../components/ui/SectionTitle";

function cn(...c) {
  return c.filter(Boolean).join(" ");
}

const Disciplines = () => {
  const [disciplines, setDisciplines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await getAllDisciplines();
        setDisciplines(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Erreur lors de la récupération des disciplines", error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <section
      id="cours"
      className={cn(
        "relative py-12 sm:py-16",
        "bg-lightBackground dark:bg-darkBackground",
        "text-slate-900 dark:text-slate-100",
      )}
    >
      <div className="mx-auto max-w-7xl px-4">
        <SectionTitle
          title="NOS DISCIPLINES"
          subtitle="Des cours pour tous les âges et tous les niveaux."
          leadClassName="font-satoshi font-black"
          emphasisClassName="font-serif italic font-black tracking-tight"
        />

        <div className="mt-10 flex flex-wrap -mx-4 justify-center">
          {loading && (
            <div className="w-full text-center text-slate-600 dark:text-slate-300 py-10">
              Chargement…
            </div>
          )}

          {!loading &&
            disciplines.map((discipline, index) => (
              <div className="w-full sm:w-1/2 md:w-1/4 p-4" key={index}>
                <DisciplineCard
                  title={discipline.nom_discipline}
                  ageRange={discipline.description_discipline}
                  imageSrc={discipline.image_discipline}
                  textDiscipline={discipline.contenu_discipline}
                />
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Disciplines;
